/**
 * 虚拟树
 */


import Tree from './Tree.vue';

export default Tree;